
function setUpIncidentBanner(root) {
  const elements = {
    buttonList: root.querySelectorAll('.js-button-list-item'),
    contentList: root.querySelectorAll('.js-content-list'),
    next: root.querySelector('.js-next'),
    prev: root.querySelector('.js-prev'),
    arrowsContainer: root.querySelector('.c-incident-banner__arrows'),
  };

  const classes = {
    buttonActive: 'c-incident-banner__button--active',
    contentActive: 'c-incident-banner__detail-holder--active',
    arrowContainerActive: 'c-incident-banner__arrows--active',
    contentVisible: 'c-incident-banner__detail--is-visible',
    toggle: 'c-incident-banner__toggle',
    toggleActive: 'c-incident-banner__toggle--active',
  };

  const state = {
    activeIndex: 0,
    totalItems: parseFloat(elements.arrowsContainer.getAttribute('data-total-items')),
  };

  function setActiveListItem(item, activeClass) {
    const itemIndex = parseFloat(item.getAttribute('data-index'));
    if (itemIndex === state.activeIndex) {
      item.classList.add(activeClass);
    }
  }

  function setArrowState() {
    if (state.activeIndex === 0) {
      elements.prev.setAttribute('disabled', '');
    } else {
      elements.prev.removeAttribute('disabled');
    }
    if (state.activeIndex === state.totalItems - 1) {
      elements.next.setAttribute('disabled', '');
    } else {
      elements.next.removeAttribute('disabled');
    }
  }

  function removeActiveState() {
    elements.buttonList.forEach(item => item.classList.remove(classes.buttonActive));
    elements.contentList.forEach(item => item.classList.remove(classes.contentActive));
  }

  function setUpArrows() {
    elements.next.addEventListener('click', () => {
      state.activeIndex += 1;
      removeActiveState();
      setActiveListItem(elements.buttonList[state.activeIndex], classes.buttonActive);
      setActiveListItem(elements.contentList[state.activeIndex], classes.contentActive);
      setArrowState();
    });
    elements.prev.addEventListener('click', () => {
      state.activeIndex -= 1;
      removeActiveState();
      setActiveListItem(elements.buttonList[state.activeIndex], classes.buttonActive);
      setActiveListItem(elements.contentList[state.activeIndex], classes.contentActive);
      setArrowState();
    });
  }

  function setUpToggle() {
    elements.buttonList.forEach((item) => {
      item.addEventListener('click', () => {
        elements.contentList.forEach((contentItem) => {
          const detail = contentItem.children[0];
          detail.classList.toggle(classes.contentVisible);
        });
        elements.buttonList.forEach((buttonItem) => {
          buttonItem.querySelector(`.${classes.toggle}`).classList.toggle(classes.toggleActive);
          const toggleState = buttonItem.getAttribute('aria-expanded') === 'false' ? 'true' : 'false';
          buttonItem.setAttribute('aria-expanded', toggleState);
        });
      });
    });
  }

  function checkShouldShowArrows() {
    if (state.totalItems > 0) {
      elements.arrowsContainer.classList.add(classes.arrowContainerActive);
    }
  }
  setUpArrows();
  // set first notice to be active
  setActiveListItem(elements.buttonList[0], classes.buttonActive);
  setActiveListItem(elements.contentList[0], classes.contentActive);
  checkShouldShowArrows();
  setUpToggle();
}


function init() {
  const incidentBanner = document.querySelector('.c-incident-banner');
  if (incidentBanner) {
    setUpIncidentBanner(incidentBanner);
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/incident-banner/incident-banner.js